import React from 'react';

import {
  StandaloneSearchBoxOptions,
  buildStandaloneSearchBox,
  SearchEngine
} from '@coveo/headless';
import { headlessEngineSearch } from '../../engine';
import { StandaloneSearchBox } from '../../components/standalone-searchbox';

type StandaloneSearchboxProps = {
  labels: string;
  resultsPage: string;
};

function StandaloneSearchbox({
  labels,
  resultsPage
}: StandaloneSearchboxProps) {
  const labelsObj = JSON.parse(labels);
  const options: StandaloneSearchBoxOptions = {
    numberOfSuggestions: 4,
    redirectionUrl: resultsPage ? resultsPage : '/',
    highlightOptions: {
      exactMatchDelimiters: {
        open: '<strong>',
        close: '</strong>'
      }
    }
  };

  const searchBoxController = buildStandaloneSearchBox(
    headlessEngineSearch as SearchEngine,
    {
      options
    }
  );

  return (
    <StandaloneSearchBox
      controller={searchBoxController}
      searchLabel={labelsObj.search}
      searchPlaceholder={labelsObj.placeholder}
      submitLabel={labelsObj.search}
      clearLabel={labelsObj.clear}
      viewResults={labelsObj.viewResults}
    />
  );
}

export default StandaloneSearchbox;
